import {Box} from '@mui/material';

import {
  BenchmarkDeltaVariant,
  getBenchmarkDeltaVariant,
} from '../../../../../components/ScoreStatCard/scoreStatUtils';
import {scorePill} from '../../../../../layouts/theme/designSystem';

export interface Props {
  delta: number | null;
}

const deltaChipStyles: Record<BenchmarkDeltaVariant, {bgcolor: string; color: string}> = {
  up: {bgcolor: scorePill.high.bgcolor, color: scorePill.high.color},
  down: {bgcolor: scorePill.low.bgcolor, color: scorePill.low.color},
  flat: {bgcolor: 'action.hover', color: 'text.secondary'},
};

const formatDeltaLabel = (delta: number): string => {
  const rounded = Math.round(delta);
  return rounded >= 0 ? `+${rounded}pts` : `${rounded}pts`;
};

export const DepartmentHealthBenchmarkDeltaChip = ({delta}: Props) => {
  const variant = getBenchmarkDeltaVariant(delta);

  if (delta === null || variant === null) {
    return (
      <Box component='span' sx={{fontSize: '13px', color: 'text.secondary'}}>
        —
      </Box>
    );
  }

  return (
    <Box
      component='span'
      sx={{
        display: 'inline-flex',
        px: 1,
        py: 0.25,
        borderRadius: '5px',
        fontSize: '11.5px',
        fontWeight: 600,
        ...deltaChipStyles[variant],
      }}
    >
      {formatDeltaLabel(delta)}
    </Box>
  );
};
